export default __webpack_public_path__ + "b51ad06aa9256ec842691eda0e0ddfc9.png";